import { render } from "./index.vue?vue&type=template&id=6b0d9c58"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6b0d9c58&lang=scss"
script.render = render

export default script